<template>
    <div>

        <div class="row">
            <div class="col-12 col-lg-10 mt-3 my-lg-0 px-0 mx-auto">
                <div class="row g-0 justify-content-evenly justify-content-sm-center align-items-center">
                    <div class="col-auto">
                        <a @click="searchType = ''"
                            :class="{
                                'erk btn btn-outline-secondary': true,
                                'active': searchType == ''
                            }" tabindex="0" href="javascript:void(0);">
                            TUTTO
                        </a>
                    </div>
                    <div class="col-auto">
                        <a @click="searchType = 'ILO'"
                            :class="{
                                'erk btn btn-outline-secondary': true,
                                'active': searchType == 'ILO'
                            }" tabindex="0" href="javascript:void(0);">ESERCIZI INTERATTIVI</a>
                    </div>
                    <div class="col-auto">
                        <a @click="searchType = 'TLO'"
                            :class="{
                                'erk btn btn-outline-secondary': true,
                                'active': searchType == 'TLO'
                            }" tabindex="0" href="javascript:void(0);">SCHEDE</a>
                    </div>
                    <div class="col-auto">
                        <a  @click="searchType = 'PA'"
                            :class="{
                                'erk btn btn-outline-secondary': true,
                                'active': searchType == 'PA'
                            }" tabindex="0" href="javascript:void(0);">PERCORSI</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="search-container mt-4 mb-0 my-lg-5">
            <div class="row">
                <div class="col-lg-10 mx-auto">
                    <div class="row">
                        <!-- Pulsante azione sinistra -->
                        <div class="col-auto col-sm mx-0 px-0">
                            <a title="" href="javascript:void(0);" class="erk btn btn-secondary collapsed cursor-pointer" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                <span class="bi bi-filter"></span>
                                <span class="d-none1 d-lg-inline-block">Filtra</span>
                            </a>
                        </div>
                        <!-- /Pulsante azione sinistra -->

                        <!-- Ricerca centrale / filtri -->
                        <div class="col col-sm-9 mx-0 px-0 col-lg-6">
                            <div class="erk form" action="#" method="post">
                                <div class="input-group">
                                    <input :value="searchText" 
                                        @input="searchText = $event.target.value"
                                        type="text" class="form-control" placeholder="" aria-label="" aria-describedby="button-addon1">
                                    <!--
                                    <button class="btn btn-primary" type="button" id="button-addon1"><i class="bi bi-search pr-1"></i> <span class="d-none d-lg-inline-block">Cerca</span></button>
                                    -->
                                </div>
                            </div>
                        </div>
                        <!-- /Ricerca centrale / filtri -->

                        <!-- Menu opzioni -->
                        <div class="col text-end d-none d-lg-inline-block">
                        </div>
                        <!-- /Menu opzioni -->
                    </div>
                </div>
            </div>
        </div>

        <div class="filters-container row">
            <div class="col-lg-10 mx-auto">
                <div class="accordion border-0" id="accordionExample">
                    <div class="accordion-item border-0">
                        <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample" style="">
                            <div class="accordion-body">
                                <div class="row">
                                    <div v-if="countActivityFacetes > 0" class="col-lg-4 col-sm-12 mb-3">
                                        <h5>Attività</h5>

                                        <ul v-if="!searchFacet.activity_str">
                                            <li v-for="(option, ok) in activityFacets" :key="ok" class="my-2">
                                                <a class="cursor-pointer" href="javascript:void(0);"
                                                    @click="onClickAddFacet('activity_str', ok)">
                                                    {{ok}} ({{option}})
                                                </a>
                                            </li>
                                        </ul>
                                        <div v-else>
                                            <a class="cursor-pointer" href="javascript:void(0);"
                                                @click="onClickRemoveFacet('activity_str')">
                                                <i class="bi bi-trash"></i>
                                                {{searchFacet.activity_str}}
                                            </a>

                                            <div class="my-3">
                                                <h5 v-if="countAbilityFacetes > 0" class="my-2">Abilità</h5>
                                                <ul v-if="!searchFacet.ability_str">
                                                    <li v-for="(option, ok) in abilityFacets" :key="ok" class="my-2">
                                                        <a class="cursor-pointer" href="javascript:void(0);"
                                                            @click="onClickAddFacet('ability_str', ok)">
                                                            {{ok}} ({{option}})
                                                        </a>
                                                    </li>
                                                </ul>
                                                <div v-else >
                                                    <a class="cursor-pointer margin-bottom" href="javascript:void(0);"
                                                        @click="onClickRemoveFacet('ability_str')">
                                                        <i class="bi bi-trash"></i>
                                                        {{searchFacet.ability_str}}
                                                    </a>

                                                    <div class="my-3">
                                                        <h5 v-if="countProcessFacetes > 0" class="my-2">Processo</h5>
                                                        <ul v-if="!searchFacet.process_str">
                                                            <li v-for="(option, ok) in processFacets" :key="ok" class="my-2">
                                                                <a class="cursor-pointer" href="javascript:void(0);"
                                                                    @click="onClickAddFacet('process_str', ok)">
                                                                    {{ok}} ({{option}})
                                                                </a>
                                                            </li>
                                                        </ul>
                                                        <div v-else>
                                                            <a class="cursor-pointer margin-bottom" href="javascript:void(0);"
                                                                @click="onClickRemoveFacet('process_str')">
                                                                <i class="bi bi-trash"></i>
                                                                {{searchFacet.process_str}}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="gradeFacets.length > 0" class="col-lg-4 col-sm-12 mb-3">
                                        <h5>Classe</h5>

                                        <ul v-if="!searchFacet.grade_str">
                                            <li v-for="(option, ok) in gradeFacets" :key="ok" class="my-2">
                                                <a @click="onClickAddFacet('grade_str', option.key)" href="javascript:void(0);"
                                                    class="cursor-pointer">
                                                    {{ option.label }} ({{option.count}})
                                                </a>
                                            </li>
                                        </ul>
                                        <div v-else>
                                            <a class="cursor-pointer margin-bottom" href="javascript:void(0);"
                                                @click="onClickRemoveFacet('grade_str')">
                                                <i class="bi bi-trash"></i>
                                                {{ results.grades[searchFacet.grade_str ]}}
                                            </a>
                                        </div>
                                    </div>

                                    <div v-if="paTypesFacets.length > 0" class="col-lg-4 col-sm-12 mb-3">
                                        <h5>Tipo percorso</h5>

                                        <ul v-if="!searchFacet.pa_type">
                                            <li v-for="(option, ok) in paTypesFacets" :key="ok" class="my-2">
                                                <a @click="onClickAddFacet('pa_type', option.key)" href="javascript:void(0);"
                                                    class="cursor-pointer">
                                                    {{ option.label }} ({{option.count}})
                                                </a>
                                            </li>
                                        </ul>
                                        <div v-else>
                                            <a class="cursor-pointer margin-bottom" @click="onClickRemoveFacet('pa_type')" href="javascript:void(0);">
                                                <i class="bi bi-trash"></i>
                                                {{ results.pa_type == 'public' ? 'Erickson' : 'Personali' }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div v-if="results" class="col-lg-10 mx-auto my-4 my-lg-1">

                <div class="row mb-4">
                    <div class="col-sm-12 col-md-8">
                        <MbContentFindPaginator
                            :numElements="results.total"
                            :rowPerPage="rowPerPage"
                            v-model="currentPage">
                        </MbContentFindPaginator>
                    </div>
                    <div class="col-sm-12 col-md-4">
                        <strong class="text-primary">Esercizi disponibili: {{results.total}}</strong>
                    </div>
                </div>

                <!-- Ciclo loop attività -->
                <div 
                    v-for="(content, ck) in results.contents" :key="ck"
                    :class="{
                    'erk-row-hover row mb-3 mb-lg-5 p-lg-2 pb-3 px-2': true,
                    'assigned': (content.disabled || contentInSession.indexOf(content.content_id) != -1),
                    'not-assigned': (!content.disabled && contentInSession.indexOf(content.content_id) == -1)
                    }">

                    <!-- Colonna sinistra - immagine -->
                    <div class="col-3 col-lg-2 px-0 cursor-pointer" tabindex="0"
                        @click="onClickPlayContent(content)" @keyup.enter="onClickPlayContent(content)">
                        <img v-if="content.type == 'PA' && content.pa_type == 'private'" src="/assets/img/percorso-custom.png" class="img-fluid" alt="Immagine percorso">
                        <img v-else :src="content.thumbnail" class="img-fluid" alt="Copertina materiale">
                    </div>
                    <!-- /Colonna sinistra - immagine -->

                    <!-- Colonna destra - dati -->
                    <div class="col-9 col-lg-10">
                        <div class="row h-100">
                            <div>
                                <div class="row align-items-start">
                                    <div>
                                        <h5 class="mb-1">{{content.name}}</h5><!-- Titolo -->
                                        <span class="d-block"><em><small>{{content.authors}}</small></em></span><!-- Autori -->
                                        <p class="mt-1"><strong>{{content.goal}}</strong></p><!-- Descrizione -->
                                        <span
                                            v-if="!isLoading && sessionId 
                                            && (content.disabled || contentInSession.indexOf(content.content_id) != -1)"
                                            class="badge bg-light" style="color: #111;">
                                            <span class="bi bi-link-45deg"></span>
                                            Assegnata
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <!-- CTA -->
                            <div class="pe-0" style="height: 40px;">
                                <div class="row h-100 align-items-end">
                                    <div class="erk-hover-toggle">
                                        <div class="text-end">
                                            <a 
                                                v-if="content.type != 'PA'"
                                                @click="onClickAddToPath(content)" class="btn btn-light"
                                                style="margin-right: 7px;">
                                                <span class="bi bi-check2-circle"></span>
                                                <span class="d-none d-lg-inline-block">Salva</span>
                                            </a>
                                            <a 
                                                v-if="content.type == 'PA' && content.pa_type == 'private'"
                                                @click="onClickRemovePath(content)" class="btn btn-light"
                                                style="margin-right: 7px;">
                                                <i class="bi bi-trash"></i>
                                                <span class="d-none d-lg-inline-block">Elimina</span>
                                            </a>
                                            <a 
                                                v-if="!isLoading && sessionId 
                                                && !content.disabled 
                                                && contentInSession.indexOf(content.content_id) == -1"
                                                @click="onClickAddContentToSession(content)" class="btn btn-light">
                                                <span class="bi bi-link-45deg"></span>
                                                <span class="d-none d-lg-inline-block">Assegna</span>
                                            </a>
                                            <div 
                                                v-if="!isLoading && sessionId 
                                                && (content.disabled || contentInSession.indexOf(content.content_id) != -1)"
                                                class="btn btn-light disabled">
                                                <span class="bi bi-link-45deg"></span>
                                                <span class="d-none d-lg-inline-block">Assegnato</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- /CTA -->
                        </div>
                    </div>
                    <!-- /Colonna destra - dati -->
                </div>
            
                <MbContentFindPaginator
                    :numElements="results.total"
                    :rowPerPage="rowPerPage"
                    v-model="currentPage">
                </MbContentFindPaginator>
            </div>
        </div>

        <MbPathsModal
            ref="modalPaths"
        ></MbPathsModal>       

        <MbPathDetailsModal
            ref="modalPathDetails"
        ></MbPathDetailsModal>
    </div>
</template>
<script>
import axios from "axios"
import MbPathsModal from './MbPathsModal'
import MbPathDetailsModal from "./MbPathDetailsModal"
import MbContentFindPaginator from "./MbContentFindPaginator"

let contentWindow = null

export default{
    components: {
        MbPathsModal,
        MbPathDetailsModal,
        MbContentFindPaginator
    },
    props: {
        userid: Number,
        sessionId: Number
    },
    data(){
        return {
            searchType: '',
            searchText: '',
            searchFacet: {},
            results: {},
            rowPerPage: 20,
            currentPage: 0,
            isLoading: false,
            contentInSession: []
        }
    },
    computed: {
        countActivityFacetes(){
            return Object.keys(this.getFacetsGreatherThanZero('activity_str')).length
        },
        activityFacets(){
            return this.getFacetsGreatherThanZero('activity_str')
        },
        countAbilityFacetes(){
            return Object.keys(this.getFacetsGreatherThanZero('ability_str')).length
        },
        abilityFacets(){
            return this.getFacetsGreatherThanZero('ability_str')
        },
        countProcessFacetes(){
            return Object.keys(this.getFacetsGreatherThanZero('process_str')).length
        },
        processFacets(){
            return this.getFacetsGreatherThanZero('process_str')
        },
        gradeFacets(){
            let facets = this.getFacetsGreatherThanZero('grade_str')

            let res = []

            if (!this.results || !this.results.grades){
                return res
            }

            for(let k in this.results.grades){
                if (!facets[k]){
                    continue
                }
                res.push({
                    key: k,
                    label: this.results.grades[k],
                    count: facets[k]
                })
            }

            return res
        },
        paTypesFacets(){
            let facets = this.getFacetsGreatherThanZero('pa_type')

            let res = []
            for(let k in facets){
                res.push({
                    key: k,
                    label: k == 'public' ? 'Erickson' : 'Personali',
                    count: facets[k]
                })
            }

            return res
        }
    },
    watch: {
        currentPage(){
            this.updateSearch()
        },
        searchText(){
            if (this.currentPage > 0){
                this.currentPage = 0
            } else {
                this.updateSearch()
            }
        },
        searchType(){
            window.$('.mobile-menu-item').removeClass('active')
            window.$('#menu-' + this.searchType).addClass('active')
            
            this.searchFacet = {}
            
            if (this.currentPage > 0){
                this.currentPage = 0
            } else if (this.searchText != ''){
                this.searchText = ''
            } else {
                this.updateSearch()
            }
        }
    },
    mounted(){
        this.updateSearch()
    },
    methods: {
        onClickAddToPath(content){
            this.$refs.modalPaths.open(content, this.userId)            
        },
        onClickPlayContent(content){
            if (content.type == 'PA'){
                this.$refs.modalPathDetails.open(content, this.userId, this.sessionId )
            } else {
                if (contentWindow !== null && !contentWindow.closed) {
                    contentWindow.close();
                }

                var height = screen.height - 100;
                var width = screen.width - 20;
                
                contentWindow = window.open("/structure/ContentPlayAction?userId=" + this.userId + "&traking=true&contentId=" + content.content_id + 
                    "&component=0&sessionId=" + this.sessionId, 
                    "", 
                    "top=0, left=0, width=" + width + ", height=" + height + ", status=no, menubar=no, toolbar=no scrollbars=no");
            }
        },
        onClickAddContentToSession(content){
            this.isLoading = true
            axios.post('/structure/session/UserSessionAction-addContentToSession', {
                sessionId: this.sessionId,
                contentId: content.content_id
            })
                .then((response) => {
                    this.isLoading = false
                    if (response.data.hasErrors){
                        alert(response.data.errors)
                        return
                    }
                    
                    this.contentInSession.push(content.content_id)
                })
                .catch((error) => {
                    this.isLoading = false
                    alert(error)
                })
        },
        getFacetsGreatherThanZero(key){
            if (!this.results || 
                !this.results.facet || 
                !this.results.facet.facet_fields ||
                !this.results.facet.facet_fields[key]){
                    return {}
                }
            
            var res = {}
            for (var k in this.results.facet.facet_fields[key]){
                if (this.results.facet.facet_fields[key][k] > 0){
                    res[k] = this.results.facet.facet_fields[key][k]
                }
            }
            return res
        },
        onClickAddFacet(key, value){
            this.searchFacet[key] = value
            this.currentPage = 0
            this.updateSearch()
        },
        onClickRemoveFacet(key){
            delete this.searchFacet[key]
            
            if (key == 'activity_str'){
                delete this.searchFacet['ability_str']
                delete this.searchFacet['process_str']
            } else if (key == 'ability_str'){
                delete this.searchFacet['process_str']
            } 

            this.updateSearch();
        },
        setType(type){
            window.$('#mobile-menu-toggle').click()
            this.searchType = type
        },
        updateSearch(){
            axios.post("/structure/content/ContentFindAction-search", {
                query: this.searchText,
                facetQuery: this.searchFacet,
                currentPage: this.currentPage,
                rowPerPage: this.rowPerPage,
                sessionId: this.sessionId,
                type: this.searchType
            })
                .then((response) => {
                    this.results = response.data.data
                })
                .catch((errors) => [
                    alert(errors)
                ])
        },
        onClickRemovePath(content){
            if (!confirm("Desideri rimuovere il percorso?")){
                return
            }

            axios.get("/structure/content/ContentPathAction-remove?contentId=" + content.content_id)
                .then(() => {
                    this.updateSearch()
                })
                .catch((errors) => [
                    alert(errors)
                ])
        }
    }
}
</script>
<style scoped>
.margin-top{
    margin-top: 20px;
}
.assigned{
    border-color: lightgrey;
}
.not-assigned{
    
}
.assigned img {
    opacity: 0.6;
}
</style>